export const useStyles = () => {
    return {
        header: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        icon: {
            fontSize: '2rem',
            '&.blue': {
                color: 'secondary.main',
            }
        }
    }
}